import React, {useEffect, useState} from 'react';
import {Breadcrumbs, Checkbox, Container, FormControlLabel, Grid, Link, Typography} from "@mui/material";
import {Link as RouterLink, useHistory, useParams} from "react-router-dom";
import {format, parse} from "date-fns";
import {useAuthUser, useSignOut} from "react-auth-kit";
import {isDealerSite, requestApi, showAlertAutoDis} from "../../utils/utils";
import GuestBar from "../../components/GuestInfo/GuestBar";
import DealersConditions from "../../components/Booking/Terms/DealersConditions";
import BookingConditions from "../../components/Booking/Terms/BookingConditions";
import PrimaryButton from "../../components/Common/PrimaryButton";

const DashboardTermsAndConditionsPage = () => {
    const [booking, setBooking] = useState(null);
    const [checkTerms, setCheckTerms] = useState(false);
    const {id} = useParams();
    const signOut = useSignOut();
    const history = useHistory();
    const user = useAuthUser();

 //bookingType
    useEffect(() => {
        getBookingById().catch();
    }, []);

    const acceptTerms = async () => {
        try {
            const {data} = await requestApi('/accept-terms', 'POST', {id: booking.id});
            if (data.status === 'success')
                return showAlertAutoDis({
                    title: 'Success',
                    text: 'Terms and Conditions accepted.',
                    manualClose: true
                }, () => {
                    history.push(`/booking/my-bookings/${booking.id}/payment`);
                });
            else
                return showAlertAutoDis({title: 'Error', text: data.message, manualClose: true}, () => {
                    history.push(`/booking/my-bookings/${booking.id}`);
                });
        } catch (e) {
            return showAlertAutoDis({title: 'Error', text: 'Unable to complete the request, please try again later.'}, () => {
                history.push(`/booking/my-bookings/${booking.id}`);
            });
        }
    };
    const getBookingById = async () => {
        try {
            const {data} = await requestApi(`/booking/get/${id}`);
            if (data.status === 'failed') return history.push('/booking/my-bookings');
            setBooking(data.booking);
        } catch (e) {
            if (e.status === 401)
                signOut();
        }
    };

    return (
        <>
            <GuestBar>
                {booking && (<Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Link component={RouterLink} underline="hover" color="inherit" to="/booking/my-bookings">
                        Bookings
                    </Link>
                    <Link component={RouterLink} underline="hover" color="inherit"
                          to={`/booking/my-bookings/${booking.id}`}>
                        {format(parse(booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                    </Link>
                    <Typography
                        color="text.primary">Terms and Conditions for booking {booking.id}</Typography>
                </Breadcrumbs>)}
            </GuestBar>

            <>
                {booking && <Container sx={{marginTop: '20px'}}>
                    <Grid container direction="column" spacing={3} alignItems={"center"} justify={"center"}>
                        <Grid item xs>
                            <Typography variant="h3" component="h3" align="center">
                                Please review our booking terms & conditions
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <div className={'termsContainer'}>
                                {booking.Type === 1 ? <DealersConditions/> : <BookingConditions/>}
                            </div>
                        </Grid>
                        <Grid item xs>
                            <FormControlLabel
                                className={'cleanCheckbox'}
                                control={
                                    <Checkbox checked={checkTerms}
                                              onChange={() => setCheckTerms(!checkTerms)}
                                              name="terms"
                                              color="primary"/>
                                }
                                label="I have read and accept the Terms and Conditions."/>
                        </Grid>
                        <Grid item xs>
                            <PrimaryButton disabled={!checkTerms} onClick={acceptTerms}>
                                Continue
                            </PrimaryButton>
                        </Grid>
                    </Grid>
                </Container>}

            </>
        </>
    );
};

export default DashboardTermsAndConditionsPage;